import React from 'react';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';

interface Props {
    children: React.ReactNode;
    docs?: string;
}

interface SubSectionProps {
    children: React.ReactNode;
}

const SettingsSection = React.forwardRef<HTMLSpanElement, Props>(function SettingsSection({ children, docs }, ref) {
    return (
        <Typography
            ref={ref}
            variant="h5"
            sx={{ display: 'flex', alignItems: 'center', fontWeight: 'bold', pb: 0.5, pt: 1, width: '100%' }}
        >
            {children}
            {docs && (
                <Link href={`https://asbplayer-jiten-docs.pages.dev/${docs}`} target="_blank">
                    <IconButton>
                        <InfoIcon />
                    </IconButton>
                </Link>
            )}
        </Typography>
    );
});

export const SettingsSubSection: React.FC<SubSectionProps> = ({ children }) => (
    <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', fontWeight: 'bold', pb: 0.5, pt: 1 }}>
        {children}
    </Typography>
);

export default SettingsSection;
